import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { postAnnouncementsList } from '../api';

const getNaaAnnouncementThunk = createAsyncThunk(
  'naa/getNaaAnnouncementThunk',
  (data) => postAnnouncementsList(data)
);

const naaAnnouncementSlice = createSlice({
  name: 'naaAnnouncement',
  initialState: {
    isLoading: false,
    showBackButton: false,
    offerData: null,
    contentTile: null,
    lockupImage: null,
  },
  reducers: {
    setBackButton: (state, action) => {
      state.showBackButton = action.payload;
    },
    updateContentTile: (state, action) => {
      state.contentTile = action.payload;
    },
    resetContentTile: (state) => {
      state.contentTile = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNaaAnnouncementThunk.pending, (state) => {
      state.isLoading = true;
    });
    // eslint-disable-next-line no-unused-vars
    builder.addCase(getNaaAnnouncementThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      const [data] = action.payload;
      state.id = data?.id;
      state.offerData = data?.offer_data;
      state.lockupImage = data?.display?.lockup_image;
    });
    builder.addCase(getNaaAnnouncementThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.offerData = null;
    });
  },
});
const { updateContentTile, resetContentTile } = naaAnnouncementSlice.actions;

// eslint-disable-next-line no-unused-vars
const setNaaAnnouncementThunk = (data) => (dispatch, getState) => dispatch(getNaaAnnouncementThunk(data));

const updateContentTileThunk = (post) => (dispatch) => dispatch(updateContentTile(post));
const resetContentTileThunk = () => (dispatch) => dispatch(resetContentTile());

export {
  setNaaAnnouncementThunk, getNaaAnnouncementThunk, updateContentTile, updateContentTileThunk, resetContentTileThunk,
};

export const { setBackButton } = naaAnnouncementSlice.actions;

export default naaAnnouncementSlice.reducer;
